module.exports = __webpack_public_path__ + "static/media/linkedInColor.a513b14c.svg";